import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import PageHttp from '~/commons/components/PageHttp.jsx';
import Padding from '../../app/components/layout/Padding.jsx';
import Article from '../../app/components/blocks/Article.jsx';

import { env, meta } from '~/commons/config';

const PageArticle = () => {
  const { _id } = useParams();
  const [res, req] = useHttpStatus();

  useEffect(() => {
    req({ url: `api/quiz/articles/${_id}` });
  }, []);

  return (
    <PageHttp res={res}>
      {(doc) => {
        meta.set({ title: doc.title });

        return (
          <>
            <Padding className="pos-sticky bg-light py-3 d-none d-md-block text-secondary">
              {env.subjects[doc.subjects[0]]?.zhhk}閱讀文章
            </Padding>
            <div className="py-3 container">
              <Article article={doc} />
            </div>
          </>
        );
      }}
    </PageHttp>
  );
};

export default PageArticle;
